import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {makeAction} from '../../redux/actions/makeAction';
import {FETCH_MINING_WORKERS} from '../../redux/actions/actionTypes';
import Workers from './workers';

class WorkersPage extends Component {
  componentDidMount() {
    this.props.fetchMiningWorkers();
  }

  render() {
    return (
      <Workers/>
    );
  }
}

WorkersPage.propTypes = {
  fetchMiningWorkers: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  fetchMiningWorkers: makeAction(FETCH_MINING_WORKERS),
};

export default connect(null, mapDispatchToProps)(WorkersPage);



// WEBPACK FOOTER //
// /src/components/pages/WorkersPage.jsx